import { render, staticRenderFns } from "./UserInfoAdd.vue?vue&type=template&id=1ab98685&"
import script from "./UserInfoAdd.vue?vue&type=script&lang=js&"
export * from "./UserInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoAdd.vue?vue&type=style&index=0&id=1ab98685&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports